import * as React from "react";

import { useTheme, Box, Stack, Typography, useMediaQuery } from "@mui/material";
import bg_adress from "../images/contact.jpg";
import confusion from "../images/hero_bg.jpg";

const FooterSection = ({}) => {
  const theme = useTheme();

  const contactsList = {
    city: "Kinshasa, CD",
    Adress: "16th road Limete, No 40 Malila Avenue",
    phone: "+243896541721",
    email: "celiitellu@gmail.com",
    linkedIn: [
      "https://www.linkedin.com/in/cris-cirhuza-9648801a8/",
      "Cris Cirhuza",
    ],
    facebook: ["https://web.facebook.com/crispin.zagabe.7/", "Cris Cirhuza"],
  };

  const smallScreen = useMediaQuery(theme.breakpoints.down(1000));
  const Screen700 = useMediaQuery(theme.breakpoints.down(700));

  return (
    <Stack>
      <Stack
        direction={"row"}
        sx={{
          alignItems: "flex-start",
          justifyContent: "center",
          flexWrap: "wrap",
          bgcolor: theme.palette.secondary.main,
          py: "2rem",
        }}
      >
        <Stack
          sx={{
            alignItems: "center",
            justifyContent: "center",
            flexWrap: "wrap",
            //mb: "5rem",
            px: "1.5rem",
            // pb: "2rem",
            width: "100%",
          }}
        >
          <Typography
            sx={{
              fontFamily: "'Oswald', sans-serif",
              fontWeight: 600,
              fontSize: "28px",
              mb: "1.5rem",
              mt: Screen700 ? "2rem" : undefined,
              textAlign: "center",
              width: "100%",
              color: theme.palette.common.white,
            }}
          >
            Where to find me
          </Typography>
          <Stack
            sx={{
              alignItems: "center",
              // py: "2rem",
              width: "100%",
            }}
          >
            {Object.entries(contactsList).map((target) => {
              return (
                <Stack
                  direction={"row"}
                  sx={{
                    my: "0.5rem",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <Typography
                    sx={{
                      color: theme.palette.grey[300],
                      fontSize: "14px",
                      fontWeight: theme.typography.fontWeightLight,
                      textAlign: "center",
                      mr: "1rem",
                    }}
                  >
                    {target[0].charAt(0).toUpperCase() + target[0].slice(1)}
                  </Typography>
                  {target[0] === "email" ? (
                    <a
                      href={`https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&su=Getting+In+Touch&to=${target[1]}&body=Monsieur Crispin Cirhuza,%0D%0`}
                      style={{
                        textDecoration: "none",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: theme.palette.common.white,
                          fontSize: "14px",
                          fontWeight: theme.typography.fontWeightMedium,
                          textAlign: "center",
                          mr: "1rem",
                        }}
                      >
                        {target[1]}
                      </Typography>
                    </a>
                  ) : target[0] === "phone" ? (
                    <a
                      href={`tel:${target[1]}`}
                      style={{
                        textDecoration: "none",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: theme.palette.common.white,
                          fontSize: "14px",
                          fontWeight: theme.typography.fontWeightMedium,
                          mr: "1rem",
                          textAlign: "center",
                        }}
                      >
                        {target[1]}
                      </Typography>
                    </a>
                  ) : ["facebook", "linkedIn"].includes(target[0]) ? (
                    <a
                      href={target[1][0]}
                      style={{
                        textDecoration: "none",
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        sx={{
                          color: theme.palette.common.white,
                          fontSize: "14px",
                          fontWeight: theme.typography.fontWeightMedium,
                          mr: "1rem",
                          textAlign: "center",
                        }}
                      >
                        {target[1].slice(1)}
                      </Typography>{" "}
                    </a>
                  ) : (
                    <Typography
                      sx={{
                        color: theme.palette.common.white,
                        fontSize: "14px",
                        fontWeight: theme.typography.fontWeightMedium,
                        mr: "1rem",
                        textAlign: "center",
                      }}
                    >
                      {target[1]}
                    </Typography>
                  )}
                </Stack>
              );
            })}
          </Stack>
        </Stack>
      </Stack>
      <Stack
        sx={{
          bgcolor: theme.palette.common.black,
          py: "1.5rem",
          px: "3rem",
          width: "100%",
        }}
      >
        <Typography
          sx={{
            color: theme.palette.common.white,
            textAlign: "center",
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: "14px",
          }}
        >
          {new Date()?.getUTCFullYear()} &copy; Crispin Cirhuza · All rights
          reserved
        </Typography>
      </Stack>
    </Stack>
  );
};

export default FooterSection;
